import { Component } from '@angular/core';

@Component({templateUrl: 'confirm-email.component.html'})
export class ConfirmEmailComponent {}
